import moment from "moment";
import { AppointmentLogJoin } from "@/repositories/appointments.repository";
import { reasonsNotInTheMessage } from "@/repositories/appointment-history";

interface ActivityLogProps {
  logs: AppointmentLogJoin[];
}

export function ActivityLog({ logs }: ActivityLogProps) {
  if (logs.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>No activity logs available for this appointment.</p>
      </div>
    );
  }

  const sorted = logs
    .slice()
    .sort((a, b) => moment(b.created_at).valueOf() - moment(a.created_at).valueOf());

  return (
    <div className="space-y-6">
      {sorted.map((log) => (
        <div key={log.id} className="border-l-2 border-primary pl-6 relative w-full">
          <span className="absolute -left-[6px] top-[5px] w-3 h-3 rounded-full bg-primary" />
          <div className="flex justify-between items-start w-full">
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-primary text-base">
                {moment(log.created_at).format("MM/DD/YYYY")}
              </h4>
              <p className="font-medium text-sm mt-1 break-words">{log.message}</p>
              {log.user?.name && (
                <p className="text-sm text-muted-foreground">By {log.user.name}</p>
              )}
              {reasonsNotInTheMessage(log).map((reason) => (
                <p key={reason} className="text-sm text-muted-foreground mt-1 break-words">Reason: {reason}</p>
              ))}
            </div>
            <time className="text-xs text-muted-foreground ml-4 flex-shrink-0">
              {moment(log.created_at).format("h:mm a")}
            </time>
          </div>
        </div>
      ))}
    </div>
  );
}
